'use strict';
exports.default = exports;
const _ = require('lodash');
const { customBetterAllDatesToMoment } = require('@common/DateUtils');
const { deburr } = require('@common/StringUtils');
// const moment = require('moment');

// Baseado no Vuetify
exports.getNestedValue = function(obj, path, fallback) {
  if(!path) {
    return obj;
  }
  const last = path.length - 1;

  if (last < 0) { return obj === undefined ? fallback : obj; }

  for (let i = 0; i < last; i++) {
    if (obj == null) {
      return fallback;
    }
    obj = obj[path[i]];
  }

  if (obj == null) { return fallback; }
  return obj[path[last]] === undefined ? fallback : obj[path[last]];
};

// Baseado no Vuetify
exports.getObjectValueByPath = function(obj, path, fallback=null, getter=null) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if((typeof path !== 'string' || !path) && typeof getter ==='function') {
    return getter(obj || fallback);
  }
  if (obj == null || !path || typeof path !== 'string') { return fallback; }
  if (obj[path] !== undefined) {
    if(typeof getter ==='function') {
      return getter(obj[path]);
    }
    return obj[path];
  }
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot

  if(typeof getter ==='function') {
    return getter(exports.getNestedValue(obj, path.split('.'), fallback), obj);
  }
  return exports.getNestedValue(obj, path.split('.'), fallback);
};

exports.transverseUndefinedToNull = function(obj, maxDeep=8) {
  if(maxDeep<=0) {
    console.warn('transverseUndefinedToNull atingiu o número máximo de profundidade');
    return;
  }
  for (const k in obj) {
    if(obj[k] === undefined) {
      obj[k] = null;
    }
    else if(typeof obj[k] === 'object') {
      exports.transverseUndefinedToNull(obj[k], maxDeep - 1);
    }
  }
  return obj;
};

exports.transverse2Date = function(obj, maxDeep=8) {
  if(maxDeep<=0) {
    console.warn('transverseUndefinedToNull atingiu o número máximo de profundidade');
    return;
  }
  for (const k in obj) {
    if(obj[k] && typeof obj[k]?.toDate === 'function') {
      obj[k] = obj[k].toDate();
    }
    else if(typeof obj[k] === 'object') {
      exports.transverse2Date(obj[k], maxDeep - 1);
    }
  }
  return obj;
};


exports.mergeSumObj = function(objs, maxDeep=8, ret= {}) {
  if(maxDeep<=0) {
    console.warn('mergeSumObj atingiu o número máximo de profundidade');
    return;
  }
  const keys = {};
  for (const obj of objs) {
    for (const j in obj) {
      keys[j] = true;
    }
  }
  for (const i in keys) {
    const objItems = [];
    for (const obj of objs) {
      if(typeof obj?.[i] ==='undefined') {
        continue;
      }
      if(typeof obj[i] === 'object') {
        objItems.push(obj[i]);
      }
      else if(typeof obj[i] === 'number') {
        ret[i] = (ret[i]||0) + obj[i];
      }
    }
    if(objItems.length) {
      ret[i] = {};
      exports.mergeSumObj(objItems, maxDeep-1, ret[i]);
    }
  }
  return ret;
};

exports.mergeObj = function(obj, objB, maxDeep=8) {
  if(maxDeep<=0) {
    console.warn('transverseUndefinedToNull atingiu o número máximo de profundidade');
    return;
  }
  const keys = {};

  for (const j in obj) {
    keys[j] = true;
  }
  for (const j in objB) {
    keys[j] = true;
  }

  for (const i in keys) {
    if (objB?.[i]) {
      if (typeof objB?.[i] === 'object') {
        if (Array.isArray(obj?.[i])) {
          continue;
        }
        else if (obj[i] instanceof Date) {
          continue;
        }
        else if (typeof obj[i]!== 'object' || obj[i]===null) {
          continue;
        }
        else if (Array.isArray(objB[i]) && _.isEmpty(obj[i])) {
          obj[i] = objB[i];
        }
        else if (objB[i] instanceof Date && _.isEmpty(obj[i])) {
          obj[i] = objB[i];
        }
        else if (Object.keys(objB[i])?.length) {
          obj[i] ||= {};
          exports.mergeObj(obj[i], objB[i], maxDeep - 1);
        }
      }
      else if (obj[i]===undefined) {
        obj[i] = objB[i];
      }
    }
  }
  return obj;
};

/**
 * Compara duas datas usando moment
 * @param {any} valueA - primeiro valor a ser comparado
 * @param {any} valueB - segundo valor a ser comparado
 * @param {Boolean|String} ascOrDesc - direção da comparação: true/asc para ascendente, false/desc para descendente
 * @returns {number|null} - resultado da comparação: -1 se valueA for menor, 1 se valueA for maior, 0 se forem iguais
 */

function customBetterCompareDates(valueA, valueB, ascOrDesc = true) {
  const isAscending = typeof ascOrDesc === 'string'
    ? ascOrDesc.toLowerCase() === 'asc'
    : !!ascOrDesc;
  const momentA = customBetterAllDatesToMoment(valueA);
  const momentB = customBetterAllDatesToMoment(valueB);

  const isValidA = momentA?.isValid?.();
  const isValidB = momentB?.isValid?.();


  if (isValidA && isValidB) {
    return isAscending ? momentA.diff(momentB) : momentB.diff(momentA);
  }

  if (isValidA) return isAscending ? -1 : 1;
  if (isValidB) return isAscending ? 1 : -1;

  return null;
}

exports.customBetterCompareDates = customBetterCompareDates;

/**
 * Converte um objeto em um array, onde cada chave do objeto se torna um índice do array
 * @param {Object} obj - O objeto a ser convertido
 * @returns {Array} - Array onde cada elemento corresponde ao valor de uma chave do objeto
 */
exports.customBetterObjectToArray = function(obj) {
  if(!obj || typeof obj !== 'object' || Object.keys(obj).length === 0) {
    return [];
  }

  const result = [];

  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const index = isNaN(Number(key)) ? key : Number(key);
      result[index] = obj[key];
    }
  }

  return result;
};

/**
 * Converte um objeto em um array de objetos com propriedades personalizáveis
 * @param {Object} obj - O objeto a ser convertido
 * @param {string} keyProp - Nome da propriedade para armazenar a chave (padrão: 'id')
 * @param {string} valueProp - Nome da propriedade para armazenar o valor (padrão: 'value')
 * @returns {Array} - Array de objetos com a estrutura definida
 */
exports.customBetterObjectToPropsArray = function(obj, keyProp = 'id', valueProp = 'value') {

  if(!obj || !Object.keys(obj).length) {
    return [];
  }

  return Object.entries(obj).map(([key, value]) => {
    const result = {};
    result[keyProp] = key;
    result[valueProp] = value;
    return result;
  });
};

exports.CUSTOM_BETTER_SORT_DEFAULT_PATH_MAPPINGS = {
  numberGuide: 'additionalData.numberProviderGuide',
  dtProcedure: 'dtProcedure',
  patient: 'patient.name',
  anesthetist: 'anesthetist.name',
  surgeon: 'surgeon.name',
  hospital: 'hospital.name',
  healthInsurance: 'healthInsurance.name',
  addedToBatch: 'meta.addedToBatchAt',
  totalProduced: 'values.totalProduced',
  type: 'type',
};

/**
 * Ordena um array de objetos com base em um campo específico
 * @param {Array} items - Array de objetos para ordenar
 * @param {String} sortBy - Campo pelo qual ordenar
 * @param {Boolean|String} isAscendingOrString - Direção da ordenação: true/asc para ascendente, false/desc para descendente
 * @param {Object} pathMappings - Mapeamentos de propriedades para caminhos de acesso
 * @returns {Array} - Array ordenado
 */
exports.customBetterSortItems = function(items, sortBy, isAscendingOrString, pathMappings = {}) {
  if (!items || !items.length || !sortBy) return items;

  const isAscending = typeof isAscendingOrString === 'string'
    ? isAscendingOrString.toLowerCase() === 'asc'
    : !!isAscendingOrString;

  const valuePath = pathMappings[sortBy] || sortBy;

  const itemsToSortArray = items.slice();

  itemsToSortArray.sort((a, b) => {
    const valueA = exports.getObjectValueByPath(a, valuePath, '');
    const valueB = exports.getObjectValueByPath(b, valuePath, '');

    // Trata valores vazios (sempre no final)
    const isEmptyA = valueA === null || valueA === undefined || valueA === '';
    const isEmptyB = valueB === null || valueB === undefined || valueB === '';
    if (isEmptyA && isEmptyB) return 0;
    if (isEmptyA) return 1;
    if (isEmptyB) return -1;

    // Trata datas Firestore
    const isDateA = valueA && typeof valueA.toDate === 'function';
    const isDateB = valueB && typeof valueB.toDate === 'function';
    if (isDateA || isDateB) {
      const momentA = customBetterAllDatesToMoment(valueA);
      const momentB = customBetterAllDatesToMoment(valueB);
      if (momentA?.isValid() && momentB?.isValid() && momentA.isSame(momentB)) return 0;
      return customBetterCompareDates(valueA, valueB, isAscending);
    }

    // Trata números
    const numA = Number(valueA);
    const numB = Number(valueB);
    if (!isNaN(numA) && !isNaN(numB)) {
      return isAscending ? numA - numB : numB - numA;
    }

    // Trata strings com localeCompare pt-BR
    const strA = deburr(String(valueA));
    const strB = deburr(String(valueB));
    const result = strA.localeCompare(strB, 'pt-BR', {
      sensitivity: 'base',
      numeric: true
    });

    return isAscending ? result : -result;
    
  });

  return itemsToSortArray;
};


/**
 * Cria uma função de ordenação específica para eventos
 * @param {Array} events - Array de eventos para ordenar
 * @param {String} sortBy - Campo pelo qual ordenar
 * @param {String} ascOrDesc - Direção da ordenação ('asc' ou 'desc')
 * @param {Object} customPathMappings - Mapeamentos personalizados de propriedades (opcional)
 * @returns {Array} - Array ordenado
 */
exports.customBetterSortEvents = function(events, sortBy = 'dtProcedure', ascOrDesc = 'asc', customPathMappings = {}) {
  const pathMappings = { ...exports.CUSTOM_BETTER_SORT_DEFAULT_PATH_MAPPINGS, ...customPathMappings };
  return exports.customBetterSortItems(events, sortBy, ascOrDesc, pathMappings);
};


/**
 * Verifica se um objeto é iterável (pode ser usado com for...of)
 * @param {any} obj - Objeto a ser verificado
 * @returns {boolean} - true se o objeto é iterável, false caso contrário
 */
exports.isIterable = function(obj) {
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === 'function';
};











